export default __webpack_public_path__ + "static/media/aktiv-grotesk-regular.b61d1723.woff";